import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

// Translation
import { FormattedMessage } from 'react-intl';
// Style
import { Modal } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ModalFilter.css';
import cx from 'classnames';

import Listings from './Listings';

import { closeFilterModal } from '../../../actions/modalActions';

// Locale
import messages from '../../../locale/messages';

const ModalFilter = ({ refetch, handleResults, type }) => {

  const dispatch = useDispatch();
  const filterModal = useSelector(state => state.modalStatus.filterModal);

  return (
    <div>
      <Modal show={filterModal} onHide={() => dispatch(closeFilterModal())} dialogClassName='loginModal reservationModalFilter'>
        <Modal.Header closeButton>
          <Modal.Title><FormattedMessage {...messages.filter} /></Modal.Title>
        </Modal.Header>
        <Modal.Body bsClass={s.logInModalBody}>
          <div className={cx(s.root, s.modalBorderBottom)}>
            <div className={s.container}>
              <Listings className={cx(s.formWidth, s.formControlSelect)}
                handleResults={handleResults}
                refetch={refetch}
                type={type}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

ModalFilter.propTypes = {
  closeFilterModal: PropTypes.any.isRequired,
  filterModal: PropTypes.bool
};

ModalFilter.defaultProps = {
  filterModal: false
};

export default withStyles(s)(ModalFilter);